module.exports = __webpack_public_path__ + "img/ring_y_0_null_1@3x.9ac70d2e.png";